// Resources icons
import arrow_icon from "@/assets/icons/resources/arrow-down.svg";
//import command_line_icon from "@/assets/icons/resources/command-line.svg";
import envelope_icon from "@/assets/icons/resources/envelope.svg";
import globe_icon from "@/assets/icons/resources/globe-alt.svg";
import heart_icon from "@/assets/icons/resources/heart.svg";
import bulb_icon from "@/assets/icons/resources/light-bulb.svg";
import { ROUTES } from "../navigation";

export const resourcesDataCompany = [
  {
    iconUrl: envelope_icon,
    title: "Contact us",
    description: "Connect with us directly for any inquiries or support needs.",
    withArrow: true,
    path: ROUTES.contactUs,
  },
  {
    iconUrl: bulb_icon,
    title: "About us",
    description: "Learn about the vision, mission, and story behind Trackmate.",
    withArrow: true,
    path: ROUTES.aboutUs,
  },
  {
    iconUrl: heart_icon,
    title: "Fleet Inquires",
    description: "Explore our comprehensive fleet solutions tailored to meet your needs.",
    withArrow: true,
    path: ROUTES.fleetInquiry,
  },
];

export const learnDataCompany = [
  {
    iconUrl: globe_icon,
    title: "Help Center",
    description:
      "Access our extensive Help Center for guides, tutorials, and troubleshooting tips to enhance your Trackmate experience.",
    withArrow: true,
    path: ROUTES.helpCenter,
  },
  {
    iconUrl: arrow_icon,
    title: "Installation guides",
    description:
      "Get started effortlessly with our detailed installation guides. Set up your Trackmate devices quickly and accurately.",
    withArrow: true,
    path: ROUTES.installationGuide,
  },
  // {
  //   iconUrl: command_line_icon,
  //   title: "API integrations",
  //   description:
  //     "Explore our API Integration section for documentation and resources to seamlessly integrate Trackmate services into your applications.",
  //   withArrow: true,
  //   path: ROUTES.APIintegration,
  // },
];
